import * as actions from './actions';

const initialState = {
	schemas: {},
	loading: false,
	error: false,
	errorDetail: null
};

function reduceFetchSchemas(state) {
	return {
		...state,
		loading: true,
		error: false
	};
}

function reduceFetchSchemasSuccess(state, action) {
	return {
		...state,
		schemas: action.payload,
		loading: false,
		error: false,
		errorDetail: null
	};
}

function reduceFetchSchemasError(state, action) {
	return {
		...state,
		error: true,
		errorDetail: action.payload,
		loading: false
	};
}

export const schema = (state, action) => {
	state = state || initialState;
	switch (action.type) {
		case actions.FETCH_SCHEMAS :
			return reduceFetchSchemas(state);
		case actions.FETCH_SCHEMAS_SUCCESS :
			return reduceFetchSchemasSuccess(state, action);
		case actions.FETCH_SCHEMAS_ERROR :
			return reduceFetchSchemasError(state, action);
		default:
			return state;
	}
};
